import React, { useState } from "react";
import { ChevronDownIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { faqs } from "../../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper px-4 py-16 sm:px-6 sm:py-24" data-id="element-146" data-mp="1223gp41gqtyo">
      <div className="mx-auto max-w-3xl" data-id="element-147" data-mp="124prrdnkbrln">
        <SectionHeading eyebrow="Frequently asked questions" title="Answers Before You Decide" data-id="element-148" data-mp="1prxsrjdykehv" />

        <div className="mt-10 space-y-3" data-id="element-149" data-mp="1urk75w5iw0s9">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="rounded-2xl bg-white" data-id="element-150" data-mp="1g24hykln43eo" data-mpi={i}>
                <h3 data-id="element-151" data-mp="1l0piym8pur46">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 rounded-2xl px-5 py-5 text-left font-display text-lg font-bold text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand sm:px-6" data-id="element-152" data-mp="1l06adw4yhf2t">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-153" data-mp="2ygtsef5mrpwq" />
                  </button>
                </h3>
                <div id={`faq-${i}`} className={`grid transition-[grid-template-rows] duration-200 ease-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`} data-id="element-154" data-mp="32iez1irkn7yh">
                  <div className="overflow-hidden" data-id="element-155" data-mp="3ch4kfliofajh">
                    <p className="px-5 pb-5 text-base leading-relaxed text-muted sm:px-6" data-id="element-156" data-mp="1n0vf1z3f6hpp">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <SectionCta label="I’m Ready — Give Me Access" data-id="element-157" data-mp="27pxor9xr7nug" />
      </div>
    </section>;
}